const config = {
  apiBaseUrl: process.env.API_BASE_URL || "https://server.selfietoons.com/api/",
};

export default config;
